import React from "react";
import { useCombobox } from "downshift";

import { useSearchApi } from "src/core/shared/api/search.api";
import useTerminology from "src/core/shared/hooks/useTerminology";

import { ProductSearchComponent } from "../ProductSearchComponent";
import { ISearchRequest } from "../ProductSearchComponent/OrderQuickProductAdd";
import { generateListProductsParams } from "../../utils";
import { IProduct } from "../../api/products.api";

interface ProductReplacementSearchProp {
  //handler to update either from or to product, defined in replacement input component
  updateReplacementHandler: (product: IProduct) => void;
  //a placeholder for the search bar, this could change depending on if its a to or from replacement
  placeholder?: string;
}

/**
 * A wrapper for The product search component for specific use with product replacements.
 * Primarily to keep things DRY
 * @returns
 */
const ProductReplacementSearch: React.FunctionComponent<ProductReplacementSearchProp> = ({ updateReplacementHandler, placeholder }) => {
  const [ productResponse, productSearch ] = useSearchApi("SEARCH_PRODUCTS");
  const terminology = useTerminology();

  const productDownShiftProps = useCombobox<IProduct>({
    items: productResponse.data ? productResponse.data.result : [],
    itemToString: () => "",
    onSelectedItemChange: changes => {
      if (changes.selectedItem) {
        updateReplacementHandler(changes.selectedItem);
      }
    }
  });

  return (
    <ProductSearchComponent
      error={productResponse.error}
      onSearch={(data: ISearchRequest) => productSearch(generateListProductsParams(data))}
      loading={productResponse.pending}
      searchResults={productResponse.data ? productResponse.data.result : []}
      downshiftProps={productDownShiftProps}
      placeholder={placeholder ? placeholder : `Search ${terminology?.product.plural.text}...`}
    />
  );
};

export default ProductReplacementSearch;